<template>
  <v-slide-y-transition mode="out-in">
    <v-layout row wrap>
      <v-flex lg12 sm12>
        <v-card pa-0 style="padding-top: 64px;">   
          <v-toolbar v-bind:color="fm.kompetisi.color" dark :fixed="true" cad>
            <v-btn icon dark @click="$emit('close', false)">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title class="subheading">Update {{fm.kompetisi.name}}</v-toolbar-title>            
            <v-chip dark v-bind:color="quickcountMode?'warning':'success'">
              <v-switch v-model="quickcountMode" v-bind:true-value="true" v-bind:false-value="false" class="mb-1" hide-details              
              ></v-switch> {{quickcountMode ? 'Quickcount':'Realcount'}}
            </v-chip>
            <v-spacer></v-spacer>
            <div class="form-btn">
              <v-btn @click="save()" v-bind:loading="loading" outline>Save</v-btn>                  
            </div>                                                                                 
          </v-toolbar>
          <v-progress-linear color="info" :indeterminate="true" v-if="loading" height="5" class="ma-0"></v-progress-linear>    
          <v-card-text class="pa-0">
            <v-container bg fill-height grid-list-md text-xs-center v-if="loading">
              <v-layout row wrap align-center>
                <v-flex>
                  <v-progress-circular
                    :size="70"
                    :width="5"
                    :color="$config.color"
                    indeterminate>
                    wait...
                  </v-progress-circular>
                </v-flex>
              </v-layout>
            </v-container>
            <v-layout row wrap class="mt-1 py-3" v-else>
              <v-flex lg6 md6 sm12 xs12>
                <v-list-tile>
                  <v-list-tile-action><v-icon color="cyan">room</v-icon></v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{fm.tps.name}}</v-list-tile-title>
                    <v-list-tile-sub-title>location : {{fm.tps.alamat}}</v-list-tile-sub-title>
                  </v-list-tile-content>                          
                </v-list-tile>                    
              </v-flex>
              <v-flex lg6 md6 sm12 xs12 >
                <v-list-tile v-if="fm.dapil">
                  <v-list-tile-action><v-icon color="cyan">language</v-icon></v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{fm.dapil.name}}</v-list-tile-title>
                    <v-list-tile-sub-title>dapil</v-list-tile-sub-title>
                  </v-list-tile-content>                          
                </v-list-tile>                    
              </v-flex>                                    
            </v-layout>
            <v-alert :value="$validator.errors.items.length==0 ? false : true" type="warning">                       
              <ul>
                <li v-for="(item) in $validator.errors.items">{{item.msg}}</li>
              </ul>
            </v-alert>
            <v-expansion-panel
              v-model="panel" flat class="elevation-0 ma-0"
              expand
            >
              <v-expansion-panel-content v-bind:key="1" class="grey lighten-1">
                <div slot="header" >I. Data Jumlah Suara Per Calon</div>
                <v-card>
                  <v-card-text>
                    <v-container grid-list-lg fluid pa-0>
                      <v-layout row wrap v-if="fm.calons.length > 0">                                            
                        <v-flex lg3 md4 sm6 xs12 v-for="(calon, i) in fm.calons">              
                          <v-card>
                            <v-toolbar :color="calon.color">
                              <v-toolbar-title class="white--text display-2">0{{calon.no}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-text-field v-if="quickcountMode" flat v-model="calon.quickcount" solo type="number" onwheel="this.blur()" placeholder="0" hide-details style="width:50%;font-size: 20px;"></v-text-field>
                              <v-text-field v-else flat v-model="calon.suara" solo type="number" onwheel="this.blur()" placeholder="0" hide-details style="width:50%;font-size: 20px;"></v-text-field>
                                <!--<div class="layout row ma-0">                            
                                  <div class="sm7 xs7 flex">
                                    <v-list-tile-avatar color="grey">            
                                      <!--<img :src="item.avatar" v-if="item.avatar">
                                      <span class="white--text headline">{{calon.no}}</span>
                                    </v-list-tile-avatar>                              
                                  </div>
                                  <div class="sm5 xs5 flex text-sm-center py-3 white--text">

                                  </div>
                                </div>-->

                            </v-toolbar>
                            <v-img
                              v-bind:src="calon.img?calon.img:require('@/assets/img/avatar/blank-eks.jpg')"
                              aspect-ratio="1.95"
                              >                                                
                            </v-img>
                            <v-card-text class="pa-0">
                              <v-container class="pa-0">                          
                                <v-divider></v-divider>                          
                                <v-flex lg12 class="align-center text-sm-center">{{calon.name}}</v-flex>
                                <v-divider></v-divider>
                                <v-flex lg12>
                                  <v-avatar size="30" class="ma-1" v-for="(partai, i) in calon.partai"  :color="partai.color">            
                                    <img :src="partai.thumb" v-if="partai.thumb"/>
                                    <span v-else class="white--text headline"></span>
                                  </v-avatar>
                                </v-flex>                          
                              </v-container>                         
                            </v-card-text>
                          </v-card>                                
                        </v-flex> 
                      </v-layout>
                      <v-alert v-else-if="!loading" :value="true" color="info" icon="info" outline>
                        <h3 class="text-sm-center">Data Calon untuk TPS ini tidak tersedia</h3>
                      </v-alert> 
                    </v-container>  
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
              <v-expansion-panel-content v-if="!quickcountMode" v-bind:key="2" class="grey lighten-2">
                <div slot="header" >II. Data Jumlah Suara Sah dan Tidak Sah</div>
                <v-card>
                  <v-card-text>
                    <div class="v-table__overflow tabular">
                      <table class="v-datatable v-table theme--light">
                        <thead>
                          <tr><th role="columnheader">No.</th>
                            <th>Uraian</th>
                            <th>Jumlah</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>Jumlah suara sah seluruh calon</td>
                            <td>{{fm.sah}}</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>Jumlah suara <strong>tidak</strong> sah</td>
                            <td><v-text-field 
                              type="number" onwheel="this.blur()" hide-details
                              v-model="fm.tdk_sah" solo 
                              style="max-width: 200px; min-width: 100px"                                   
                              placeholder="0" 
                              required
                              data-vv-name="tdk_sah"  
                              v-bind:error-messages="errors.collect('tdk_sah')"                                                                     
                              >                                    
                            </v-text-field></td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>Jumlah suara sah dan tidak sah (1+2)</td>
                            <td>{{parseInt(fm.sah) + parseInt(fm.tdk_sah)}}</td>
                          </tr>
                        </tbody>
                      </table>  
                    </div>  
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>                  
              <v-expansion-panel-content v-if="!quickcountMode" v-bind:key="3" class="grey lighten-1">
                <div slot="header" >III. Data Penggunaan Surat Suara</div>
                <v-card>
                  <v-card-text>
                    <div class="v-table__overflow tabular">
                      <table class="v-datatable v-table theme--light">
                        <thead>
                          <tr><th role="columnheader">No.</th>
                            <th>Uraian</th>
                            <th>Jumlah</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>Jumlah surat suara yang digunakan</td>
                            <td>{{fm.digunakan=(parseInt(fm.sah) + parseInt(fm.tdk_sah))}}</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>Jumlah surat suara yang <strong>tidak</strong> digunakan</td>
                            <td><v-text-field v-model="fm.tdk_digunakan" solo style="max-width: 150px; min-width: 100px" class="elevation-3 grey lighten-2" hide-details placeholder="0" type="number" onwheel="this.blur()"></v-text-field></td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>Jumlah surat suara yang dikembalikan pemilih karena rusak</td>
                            <td><v-text-field v-model="fm.rusak" solo style="max-width: 150px; min-width: 100px" class="elevation-3 grey lighten-2" hide-details placeholder="0" type="number" onwheel="this.blur()"></v-text-field></td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>Jumlah surat suara yang diterima termasuk cadangan 2% (1+2+3)</td>
                            <td>{{parseInt(fm.digunakan)+parseInt(fm.tdk_digunakan)+parseInt(fm.rusak)}}</td>
                          </tr>
                        </tbody>
                      </table>  
                    </div>  
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
              <v-expansion-panel-content v-if="!quickcountMode" v-bind:key="4" class="grey lighten-2">
                <div slot="header" >IV. Data Pemilih dan Penggunaan Hak Pilih</div>
                <v-card>
                  <v-card-text>
                    <div class="v-table__overflow tabular">
                      <table class="v-datatable v-table theme--light">
                        <thead>
                          <tr><th role="columnheader">Bag.</th>
                            <th>No.</th>
                            <th>Uraian</th>
                            <th>Jumlah</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>A</td>                                
                            <td colspan="2"><strong>DATA PEMILIH</strong></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>1</td>
                            <td>Pemilih terdaftar dalam Daftar Pemilih Tetap (DPT)</td>
                            <td><span style="display:none">{{fm.dpt=fm.dpt ? fm.dpt : parseInt(fm.tps.pt_l)+parseInt(fm.tps.pt_p)}}</span>
                              <v-text-field v-model="fm.dpt" solo style="max-width: 150px; min-width: 100px" class="elevation-3 grey lighten-2" hide-details placeholder="0" type="number" onwheel="this.blur()"></v-text-field>
                            </td>
                          </tr>                          
                          <tr>
                            <td></td>
                            <td>2</td>
                            <td>Pemilih dari Daftar Pemilih Tambahan (DPTb)</td>
                            <td><v-text-field v-model="fm.dptb" solo style="max-width: 150px; min-width: 100px" class="elevation-3 grey lighten-2" hide-details placeholder="0" type="number" onwheel="this.blur()"></v-text-field></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>3</td>
                            <td>Pemilih terdaftar dalam Daftar Pemilih Khusus (DPK)</td>
                            <td><v-text-field v-model="fm.dpph" solo style="max-width: 150px; min-width: 100px" class="elevation-3 grey lighten-2" hide-details placeholder="0" type="number" onwheel="this.blur()"></v-text-field></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>4</td>
                            <td>Jumlah Pemilih (1+2+3)</td>
                            <td>{{(parseInt(fm.dpt)+parseInt(fm.dpph)+parseInt(fm.dptb))}}</td>
                          </tr>
                          <tr>
                            <td>B</td>                                
                            <td colspan="2"><strong>PENGGUNA HAK PILIH</strong></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>1</td>
                            <td>Penggunaan hak pilih dalam Daftar Pemilih Tetap (DPT)</td>
                            <td><v-text-field v-model="fm.pen_dpt" solo style="max-width: 150px; min-width: 100px" class="elevation-3 grey lighten-2" hide-details placeholder="0" type="number" onwheel="this.blur()"></v-text-field></td>
                          </tr>                          
                          <tr>
                            <td></td>
                            <td>2</td>
                            <td>Penggunaan hak pilih dalam Daftar Pemilih Tambahan (DPTb)</td>
                            <td><v-text-field v-model="fm.pen_dptb" solo style="max-width: 150px; min-width: 100px" class="elevation-3 grey lighten-2" hide-details placeholder="0" type="number" onwheel="this.blur()"></v-text-field></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>3</td>
                            <td>Penggunaan hak pilih dalam Daftar Pemilih Khusus (DPK)</td>
                            <td><v-text-field v-model="fm.pen_dpph" solo style="max-width: 150px; min-width: 100px" class="elevation-3 grey lighten-2" hide-details placeholder="0" type="number" onwheel="this.blur()"></v-text-field></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>4</td>
                            <td>Jumlah seluruh pengguna hak pilih (1+2+3)</td>
                            <td>{{parseInt(fm.pen_dpt)+parseInt(fm.pen_dpph)+parseInt(fm.pen_dptb)}}</td>
                          </tr>
                        </tbody>
                      </table>  
                    </div>  
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
              <v-expansion-panel-content v-if="!quickcountMode" v-bind:key="5" class="grey lighten-1">
                <div slot="header" >V. Upload Foto Form C1 Plano</div>
                <v-card class="blue-grey lighten-5">                 
                  <v-card-text class="viewer">
                    <h3>Current Photo</h3>
                    <viewer :images="images">
                      <img v-for="src in images" :src="src" :key="src" style="max-width:200px; width:50%;">
                    </viewer>
                  </v-card-text>
                </v-card>
                <v-card>
                  <v-card-text>
                    <div class="DashboardContainer"></div>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>  
            </v-expansion-panel>

          </v-card-text>
        </v-card>  
      </v-flex>
    </v-layout>
  </v-slide-y-transition>
</template>

<script>  
import Model from '@/apps/frc/models/Hitung';    
import {Slider} from 'vue-color';
import Interface   from '@/util/interface';
import 'uppy/dist/uppy.min.css';

const Uppy = require('@uppy/core')
const Dashboard = require('@uppy/dashboard')
const XHRUpload = require('@uppy/xhr-upload')
//const GoogleDrive = require('@uppy/google-drive')
//const Dropbox = require('@uppy/dropbox')
const Instagram = require('@uppy/instagram')
const Webcam = require('@uppy/webcam')
//const Tus = require('@uppy/tus')

import 'viewerjs/dist/viewer.css'
import Viewer from "v-viewer/src/component.vue"

const model = new Model();
const api = Interface.biz4;

export default {    
    components: {
      'slider-picker': Slider,
      Viewer
    },
    $_veeValidate: {
        validator: 'new'
    },           
    props:{ 
      fm : Object,
      kompetisi_id : {type:String, default:null},
      tps_id : {type:String, default:null},  
    },
    data: () => ({     
        panel: [true,true,true,true,true,true],
        loading : false,
        quickcountMode : false,
        images : [],        
        uppy:null,
        rest: null,
    }),
    watch:{        
      kompetisi_id(newVal){        
        this.init();        
      },
      tps_id(newVal){        
        this.init();        
      },      
    },
    created () { 
      //this.init();
    },        
    mounted () {
      this.$validator.localize('en', this.dictionary);                  
      //this.init();      
    }, 
    methods : {        
      
        init(){                        
            /*this.loading = true; this.resetFm();           
            
            model.surat({kompetisi_id:this.fm.kompetisi_id, tps_id:this.fm.tps_id}).then(res=>{
              if(res.status === 200){
                  Object.assign(this.fm, res.data);  
                  
              }
              this.loading = false;               
            });*/  
            
            this.watching();
            this.setImages();
            
            setTimeout(()=>{
              if(!this.uppy){
                this.setUploads();
              } else {
                this.uppy.cancelAll();
                this.rest = api.setter('frc/hitung/c1-upload?kompetisi_id='+this.fm.kompetisi_id+'&tps_id='+this.fm.tps_id);                    
                this.uppy.getPlugin('XHRUpload').endpoint = this.rest;                
              }
            }, 100);
        },
        
        resetFm(){
          this.fm.calons = [];
          this.fm.sah = null;
          this.fm.tdk_sah = null;
          
          this.fm.digunakan= null;
          this.fm.tdk_digunakan= null;
          this.fm.rusak = null;
          
          this.fm.dpt_l = null;
          this.fm.dpt_p = null;
          
          this.fm.dpt  = null;
          this.fm.dpph = null;
          this.fm.dptb = null;
          
          this.fm.pen_dpt  = null;
          this.fm.pen_dpph = null;
          this.fm.pen_dptb = null;
        },
        
        watching(){          
          this.fm.calons.forEach((calon,i)=>{
            this.$watch(['fm','calons',i,'suara'].join('.'), (suara)=>{if(suara!==null){
              this.setSah();
            }});                        
          });
          this.setSah();
        },
        
        setSah(){
          this.fm.sah = 0;
          this.fm.calons.forEach((cal)=>{
            this.fm.sah += cal.suara ? parseInt(cal.suara):0;             
          });
        },
        
        async save(isUpdate = false) {                
            this.$validator.validateAll();    
            this.fm.time = this.$moment().valueOf();
            this.fm.info = null;
            if( !this.errors.any() ) { this.loading = true;
                var res = isUpdate ? await model.update(this.fm): await model.create(this.fm);                
                if(res.status === 200){   
                    this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
                    this.$emit('close', true);                    
                } else {
                    var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
                    var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
                    if(res.data){ if(res.data.message){ text += ' ' + res.data.message; } else {this.validate(res.data);}}                
                    this.$swal({type: 'error', title: title, text: text});                    
                } this.loading = false;
            }             
        },
               
        validate(data){
            data.forEach( (item) => {
                this.$validator.errors.add({field : item.field,msg : item.message});
            });
        },        
                            
        clear () {
            this.fm = {};
            this.$validator.reset();
        },
    
        customFilter (item, queryText, itemText) {
            const textOne = item.name.toLowerCase()
            //const textTwo = item.abbr.toLowerCase()
            const searchText = queryText.toLowerCase()

            return textOne.indexOf(searchText) > -1; 
        },   
        
        setImages(){
            this.images = [];            
            model.getC1Download({kompetisi_id:this.fm.kompetisi_id,tps_id:this.fm.tps_id}).then(res=>{
                if(res.status === 200){this.images = res.data;}
            });
        },
        
        setUploads(){
          
          this.rest = api.setter('frc/hitung/c1-upload?kompetisi_id='+this.fm.kompetisi_id+'&tps_id='+this.fm.tps_id);
          this.uppy = Uppy({
            debug: false,
            autoProceed: false,
            restrictions: {
              maxFileSize: 10000000,
              maxNumberOfFiles: 2,
              minNumberOfFiles: 1,
              //allowedFileTypes: ['application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
              allowedFileTypes: ['image/*']
            }
          })
          .use(Dashboard, {
            trigger: '.UppyModalOpenerBtn',
            inline: true,
            target: '.DashboardContainer',
            replaceTargetContent: true,
            showProgressDetails: true,
            note: 'Image only, just 2 file, up to 10 MB',
            height: 300,
            width:'100%',
            metaFields: [
              { id: 'name', name: 'Name', placeholder: 'file name' },
              { id: 'caption', name: 'Caption', placeholder: 'describe what the file is about' }
            ],
            browserBackButtonClose: true
          })
          //.use(GoogleDrive, { target: Dashboard, serverUrl: 'https://companion.uppy.io' })
          //.use(Dropbox, { target: Dashboard, serverUrl: 'https://companion.uppy.io' })
          .use(Instagram, { target: Dashboard, serverUrl: 'https://companion.uppy.io' })
          .use(Webcam, { target: Dashboard })
          //.use(Tus, { endpoint: 'https://master.tus.io/files/' })
          .use(XHRUpload, {
            endpoint: this.rest.endpoint,
            headers: this.rest.headers,
            formData: true,
            fieldName: 'content',        
          })
          this.uppy.on('complete', (result) => {
            if(result.successful){
              this.setImages();
            }
            //console.log('successful files:', result.successful);
            //console.log('failed files:', result.failed);        
          });      
        },
    }
}
</script>
<style>
.uppy-Dashboard-poweredBy {
    display: none!important;
    text-align: center!important;
    font-size: 11px!important;
    color: #939393!important;
    text-decoration: none!important;
    margin-top: 8px!important;
}

.viewer img{margin-right: 5px}

</style>  